import { createPhaseActions, phaseAction } from 'src/helpers/redux'
import * as notificationTypes from 'src/services/notifications/types'

export const PREFIX = 'notifications'
export const PREFIX_SAGE = `${PREFIX}/saga`

export const actions = createPhaseActions(PREFIX_SAGE, {
  getNotifications: phaseAction<notificationTypes.IGetNotificationsParams>(),
  getNotificationsCount:
    phaseAction<notificationTypes.IGetNotificationsCountParams>(),
  postNotificationsMarkAsRead:
    phaseAction<notificationTypes.IPostNotificationsMarkAsReadParams>(),
})
export type Actions = typeof actions
